import { Link } from 'react-router-dom';
import Logo from './Logo';
import AnchorLink from './AnchorLink';
import site from '../content/site';

const SERVICE_LINKS = ['Web platforms', 'Mobile apps', 'AI and LLM', 'Cloud and DevOps'];
const COMPANY_LINKS = [
  { label: 'Work', href: '#work' },
  { label: 'Industries', href: '#industries' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-bg">
      <div className="container-site pb-7 pt-14">
        <div className="grid gap-10" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))' }}>
          <div>
            <Logo variant="light" as="span" />
            <p className="mt-3.5 max-w-[300px] text-[15px] text-neutral-400">{site.tagline}</p>
          </div>
          <nav aria-label="Services" className="flex flex-col gap-2 text-[15px]">
            <span className="mb-1 text-label uppercase text-neutral-500">Services</span>
            {SERVICE_LINKS.map(l => <AnchorLink key={l} href="#services" className="hover:text-accent">{l}</AnchorLink>)}
          </nav>
          <nav aria-label="Company" className="flex flex-col gap-2 text-[15px]">
            <span className="mb-1 text-label uppercase text-neutral-500">Company</span>
            {COMPANY_LINKS.map(l => <AnchorLink key={l.href} href={l.href} className="hover:text-accent">{l.label}</AnchorLink>)}
          </nav>
        </div>
        <div className="mt-14 flex flex-wrap justify-between gap-4 border-t-2 border-neutral-700 pt-5 text-[13px] text-neutral-400">
          <span>© {site.year} {site.name}</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-accent">Privacy</Link>
            <Link to="/terms" className="hover:text-accent">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
